<template>
  <div>
    <div class="info-item" style="margin-left:0">
      <span><span style="color:red">*</span>拜访单位：
        <Input
          v-model="min_purchaserVisitListData.clientNmae"
          style="width:300px"
          readonly
        /></span>
        <Button type="primary" @click="selectCgrVisible=true" size="small">选择</Button>
    </div>
    <div class="info-item">
      <span><span style="color:red">*</span>客户人员：
        <Input
          v-model="min_purchaserVisitListData.am"
          style="width:150px"
          readonly
        /></span>
    </div>
    <div class="info-item">
      <span><span style="color:red">*</span>归属团队：
        <Select
          v-model="min_purchaserVisitListData.filiale"
          style="width:150px;display:inline-block;"
          :disabled="!editStatus_1"
        >
          <Option
            v-for="item in companyArea"
            :value="item.name"
            :key="item.id"
          >{{ item.name }}</Option>
        </Select>
      </span>
    </div>

    <div class="info-item" style="margin-left:0">
      <span><span style="color:red">*</span>跟进途径：
        <Select
          v-model="min_purchaserVisitListData.followApproach"
          style="width:150px;display:inline-block;"
          :disabled="!editStatus_1"
        >
          <Option value="当面拜访">当面拜访</Option>
          <Option value="电话访谈">电话访谈</Option>
        </Select>
      </span>
    </div>
    <div class="info-item">
      <span><span style="color:red">*</span>拜访原因：
        <Select
          v-model="min_purchaserVisitListData.isNewClient"
          style="width:110px;display:inline-block"
          :disabled="!editStatus_1"
        >
          <Option value="关系维护">关系维护</Option>
          <Option value="项目洽谈">项目洽谈</Option>
          <Option value="陌生拜访">陌生拜访</Option>
        </Select>
      </span>
    </div>

    <div class="info-item">
      <span><span style="color:red">*</span>拜访日期：
        <DatePicker
          type="date"
          show-week-numbers
          placeholder=''
          v-model="min_purchaserVisitListData.visitDate"
          style="width: 150px"
          @on-change="timechange"
          :readonly='!editStatus_1'
        ></DatePicker>
      </span>
    </div>
    <div class="info-item">
      <span><span style="color:red">*</span>拜访时间：
        <TimePicker 
          format="HH:mm" 
          type="timerange" 
          placement="bottom-end"
          v-model="visitDateRange"
          style="width: 150px" 
          :readonly='!editStatus_1'>
        </TimePicker>
      </span>
    </div>

    <div class="info-item" style="margin-left:0">
      <span>拜访地址：
        <Input
          v-model="min_purchaserVisitListData.adderss"
          style="width:356px"
          readonly
        />
      </span>
    </div>
    <!-- <div class="info-item">
      <span>顾客名片：
        <img
          :src="min_purchaserVisitListData.bcImageLocation"
          v-show="!editStatus_1"
          style="width:30px;vertical-align:middle;"
          @click="wpic(min_purchaserVisitListData.bcImageLocation)"
        />
        <div
          class="oss_file"
          v-show="add||editStatus_1"
          style="display:inline-block;vertical-align:middle;"
        >
          <span class="img_style">
            <Icon
              type="ios-cloud-upload-outline"
              size="20"
              style="vertical-align:middle"
            ></Icon>
          </span>
          <input
            type="file"
            style="height:30px;"
            @change="uploadFile($event)"
          />
          <div style="display:inline-block;vertical-align:top;margin-left:10px;">
            <img
              :src="picSrc"
              style="width:30px;"
              @click="wpic(picSrc)"
            />
          </div>
        </div>
      </span>
    </div> -->
    <!-- 联系人table -->
    <div class="info-item" v-show="editStatus_1">
      <span><span style="color:red">*</span>单位联系人：</span>
      <Select v-model="contactPersonOrWay" multiple style="width:320px;margin-right:5px" placeholder="可多选">
        <Option v-for="(item) in contactArr" :value="item['联系人']" :key="item['联系人']">{{ item['联系人'] }}</Option>
      </Select>
      <Button type="primary" @click="addVisible=true" size="small" :disabled="!this.min_purchaserVisitListData.clientNmae">新增</Button>
    </div>
    <Table :columns="columns" :data="selectedContact"></Table>
    <div style="margin-top:10px">
      <p><span style="color:red">*</span>拜访结果：</p>
        <textarea v-model="min_purchaserVisitListData.visitResult" class="textarea" :readonly="!editStatus_1" placeholder="请详细记录拜访的情况"></textarea>
    </div>
    <div v-show="!add" style="text-align:center;margin-top:10px">
      <Button type="primary" @click="editInfo" v-show="!editStatus_1 && editPermission">
        修改记录信息
      </Button>
      <Button type="primary" @click="editPost" v-show="editStatus_1">
        确定修改
      </Button>
      <Button type="primary" @click="editCancel" v-show="editStatus_1">
        取消修改
      </Button>
    </div>
    <div v-show="add" style="text-align:center;margin-top:10px">
      <Button type="primary" @click="addSureConfirm">
        添加拜访记录
      </Button>
    </div>
    <Modal
      v-model="wPicInfo"
      title="名片详情"
      width="950"
      style="z-index:999"
      :transfer="false"
    >
      <picCard :img-src="imgSrc"></picCard>
    </Modal>
    <!-- 联系人弹窗 -->
    <Modal v-model="addVisible" title="新增联系人" width="680" :transfer="false" :mask-closable="false">
      <Form ref="contactForm" :model="contactForm" :rules="ruleValidate" :label-width="80">
        <Row>
          <Col span="12">
            <FormItem label="姓名" prop="联系人">
              <Input v-model="contactForm['联系人']" placeholder="请输入姓名"></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="性别" prop="性别">
              <RadioGroup v-model="contactForm['性别']">
                <Radio label="男">男</Radio>
                <Radio label="女">女</Radio>
              </RadioGroup>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="6">
            <FormItem label="职位" prop="职位">
              <Input v-model="contactForm['职位']" placeholder="请输入职位"></Input>
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem label="部门" prop="部门">
              <Input v-model="contactForm['部门']" placeholder="请输入部门"></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="座机" prop="座机号码">
              <Input v-model="contactForm['座机号码']" placeholder="请输入固定电话"></Input>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
            <FormItem label="手机" prop="联系方式">
              <Input v-model="contactForm['联系方式']" placeholder="请输入手机号码"></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="邮箱" prop="邮箱">
              <Input v-model="contactForm['邮箱']" placeholder="请输入个人邮箱"></Input>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="ghost" @click="addVisible=false">取消</Button>
        <Button type="primary" @click="handleSubmit('contactForm')" style="margin-left: 8px">确定</Button>
      </div>
    </Modal>
    <!-- 采购人modal -->
    <Modal v-model="selectCgrVisible" width="800px" :transfer="false">
      <div slot="header">
        采购人选择
      </div>
      <select-cgr @selected="selectedCgr"></select-cgr>
      <div slot="footer">
        <Button @click="selectCgrVisible=false">取消</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import picCard from "./picCard"
import axios from 'axios'
import qs from 'qs'
import requestUrls from '@/lib/eRequestUrls'
import { upload } from '@/lib/file_s'
import OSS from 'ali-oss'
import ajax from '@/lib/ajax'
import { formatDate } from '@/lib/tool'
import selectCgr from "@/components/setProject/selectCgr"

export default {
  components: {
    picCard,
    selectCgr
  },
  props: {
    curVisitListData: {
      type: Object
    },
    addStatus: {
      type: String
    },
    editPermission: Boolean,
    info: Object
  },
  data() {
    return {
      imgSrc: "",//名片地址
      wPicInfo: false,
      min_purchaserVisitListData: JSON.parse(JSON.stringify(this.curVisitListData)),
      add: '',//false 表示详情页面处于展示状态，true 表示详情页面处于新添加状态
      editStatus_1: '', //false 表示详情页面处于展示状态，true 表示详情页面处于可编辑状态
      file: '', //上传的文件信息
      picSrc: '', //上传图片的本机地址
      showSus: false,
      companyArea: [],//保存分公司 
      visitDateRange: [],  // 拜访时间
      selectCgrVisible: false,
      contactPersonOrWay: [],
      columns: [
        {
          title: '姓名',
          key: '联系人'
        },
        {
          title: '性别',
          key: '性别'
        },
        {
          title: '职位',
          key: '职位'
        },
        {
          title: '部门',
          key: '部门'
        },
        {
          title: '邮箱',
          key: '邮箱'
        },
        {
          title: '手机',
          key: '联系方式'
        },
        {
          title: '座机',
          key: '座机号码'
        }
      ],
      addVisible: false,
      contactForm: {
        '联系人': '',
        '联系方式': '',
        '座机号码': '',
        '性别': '',
        '职位': '',
        '部门': '',
        '邮箱': '',
        '名片': ''
      },
      ruleValidate: {
        '联系人': [
            { required: true, message: '姓名不能为空', trigger: 'blur' }
        ],
        '联系方式': [
            { required: true, message: '手机号码不能为空', trigger: 'blur' },
            { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        '座机号码': [
            { required: true, message: '座机号码不能为空', trigger: 'blur' }
        ],
        '性别': [
            { required: true, message: '请选择性别', trigger: 'change' }
        ]
      },
      cgrInfo: {},
      contactArr: []
    }
  },
  // 得到分公司列表
  async created() {
		let rep = await ajax.get(requestUrls.CLDistrict.GetListWithoutRole)
		this.companyArea = []
		if (rep.data.success) {
			this.companyArea = rep.data.result.items
    }
  },
  computed: {
    selectedContact() {
      return this.add 
      ? this.contactArr.filter(item => this.contactPersonOrWay.indexOf(item['联系人']) != -1) 
      : this.curVisitListData.contact ? JSON.parse(this.curVisitListData.contact) : []
    }
  },
  watch: {
    //更新 card 的值
    addStatus() {
      this.picSrc = '';//避免上一次新增记录遗留下的本地图片地址
      this.file = '';//避免上一次新增记录遗留下的本地图片地址
      this.min_purchaserVisitListData = JSON.parse(JSON.stringify(this.curVisitListData));
      this.min_purchaserVisitListData.am = this.$store.state.session.user.name
      if (this.info) this.selectedCgr(this.info)
      if (this.min_purchaserVisitListData.visitDateRange) {
        this.visitDateRange = this.min_purchaserVisitListData.visitDateRange.split('-')
      } else {
        this.visitDateRange = []
      }
      var val = this.addStatus.split('+');
      if (val[0] == 'false') {
        this.editStatus_1 = false; // 表示查看信息  处理 不可编辑状态 
        this.add = false; // 表示 从 查看信息处进入
      } else {
        this.editStatus_1 = true; // 查看信息 处于 可编辑状态
        this.add = true; // 表示从  新增记录 处进入
      }
    }
  },
  methods: {
    // 点击“修改记录信息”按钮，使数据处于可编辑状态，
    editInfo() {
      this.editStatus_1 = true;
      this.picSrc = this.min_purchaserVisitListData.bcImageLocation;
    },
    //记录修改-- 提交修改数据
    editPost() {
      // 判断必填信息 填写 情况
      if (!this.min_purchaserVisitListData.clientNmae
        || !this.min_purchaserVisitListData.am
        || !this.min_purchaserVisitListData.filiale
        || !this.min_purchaserVisitListData.followApproach
        || !this.min_purchaserVisitListData.visitResult
        || !this.min_purchaserVisitListData.visitDate
        || this.visitDateRange.length == 0
        || !this.min_purchaserVisitListData.isNewClient
        || this.contactPersonOrWay.length == 0) {
        this.$Modal.info({
          title: '提示',
          content: '存在必填信息未填!(*为必填信息)'
        });
        return;
      }
      this.$Modal.confirm({
        title: '二次确定',
        content: '<p>是否确定修改采购人拜访记录</p>',
        onOk: () => {
          this.editStatus_1 = false;
          this.addSure();
        },
        onCancel: () => {
          this.$Message.info('取消成功');
        }
      });
    },
    //记录修改-- 取消修改数据，并将显示数据调整为原来数据
    editCancel() {
      this.editStatus_1 = false;
      this.min_purchaserVisitListData = JSON.parse(JSON.stringify(this.curVisitListData));
    },
    // 调成时间
    timechange(value) {
      
    },
    // 点击图片 查看图片详情
    wpic(value) {
      this.imgSrc = value;
      this.wPicInfo = true;
    },
    async addSureConfirm() {
      if (!this.min_purchaserVisitListData.clientNmae
        || !this.min_purchaserVisitListData.am
        || !this.min_purchaserVisitListData.filiale
        || !this.min_purchaserVisitListData.followApproach
        || !this.min_purchaserVisitListData.visitResult
        || this.visitDateRange.length == 0
        || !this.min_purchaserVisitListData.isNewClient
        || this.contactPersonOrWay.length == 0) {
        this.$Modal.info({
          title: '提示',
          content: '存在必填信息未填!(*为必填信息)'
        });
        return;
      }
      this.$Modal.confirm({
        title: '二次确定',
        content: '<p>是否确定填写的采购人信息</p>',
        onOk: () => {
          this.addSure();
        },
        onCancel: () => {
          this.$Message.info('取消成功');
        }
      });
    },
    //添加记录-- 确定添加拜访记录
    async addSure() {
      // 若有上传名片 则出现 loading 
      if (this.file) {
        this.$Spin.show({
          render: (h) => {
            return h('div', [
              h('Icon', {
                'class': 'demo-spin-icon-load',
                props: {
                  type: 'load-c',
                  size: 18
                }
              }),
              h('div', 'Loading')
            ])
          }
        });
      }

      var res = await this.aliyunUpload()
      if (res) {
        // let req = await axios({
        //   method: 'post',
        //   url: '/api/services/app/CLCustomerVisit/CreateOrUpdate',
        //   data: {
        //     clCustomerVisit: parmas
        //   }
        // })

        let req = await ajax.post('/api/services/app/CLCustomerVisit/CreateOrUpdate', {
          clCustomerVisit: {
            "id": this.curVisitListData.id,
            "clientNmae": this.min_purchaserVisitListData.clientNmae,
            "am": this.min_purchaserVisitListData.am,
            "filiale": this.min_purchaserVisitListData.filiale,
            "followApproach": this.min_purchaserVisitListData.followApproach,
            "adderss": this.min_purchaserVisitListData.adderss,
            "visitResult": this.min_purchaserVisitListData.visitResult,
            "visitDate": formatDate(this.min_purchaserVisitListData.visitDate),
            "isNewClient": this.min_purchaserVisitListData.isNewClient,
            "bcImageLocation": this.min_purchaserVisitListData.bcImageLocation,
            "businessCard": this.min_purchaserVisitListData.businessCard,
            "checkInAddress": this.min_purchaserVisitListData.checkInAddress,
            "checkInDate": this.min_purchaserVisitListData.checkInDate,
            "visitDateRange": this.visitDateRange[0] + '-' + this.visitDateRange[1],
            "purchaseId": this.cgrInfo.id,
            "contact": JSON.stringify(this.selectedContact)
          }
        })
        if(req.data.success) {
          this.$Spin.hide(); //关闭 Loading
          this.$Message.success('操作成功');
          this.$emit('ok', false) //关闭父组件所在 Modal
          this.contactArr = []
        } else {
          this.$Spin.hide();
        }
        // if (req.data.code == 200) {
        //   this.$Spin.hide(); //关闭 Loading
        //   this.$Message.success('操作成功');
        //   this.$emit('ok', false) //关闭父组件所在 Modal
        // } else {
        //   this.$Spin.hide();
        // }
      }
    },
    selectedCgr(cgrInfo) {
      this.contactPersonOrWay = []
      this.contactArr = []
      this.selectCgrVisible = false
      let contact = cgrInfo.contactPersonOrWay
      if (typeof contact == 'string') {
        contact = contact.replace(/\'/g, '"')
        if (contact.indexOf('[') == -1) {
          contact = `[${contact}]`
        }
        contact = JSON.parse(contact)
      }
      this.cgrInfo = cgrInfo
      this.contactArr = contact
      this.min_purchaserVisitListData.clientNmae = cgrInfo.purchase
      this.min_purchaserVisitListData.adderss = `${cgrInfo.province||''}${cgrInfo.city||''}${cgrInfo.area||''}${cgrInfo.contactAddress}`
      if (this.min_purchaserVisitListData.adderss == 'null') this.min_purchaserVisitListData.adderss = ''
    },
    // 添加联系人与方式
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          // 邮箱格式是否正确
          let reg = /^([0-9A-Za-z\-_\.]+)@([0-9a-z]+\.[a-z]{2,3}(\.[a-z]{2})?)$/g
          if (!this.contactForm['邮箱']||reg.test(this.contactForm['邮箱'])) {
            this.$Modal.confirm({
              title: '新增联系人',
              content: '<p>确定添加新联系人吗？</p>',
              onOk: () => {
                // 修改联系人信息
                this.cgrInfo.contactPersonOrWay = JSON.stringify([...this.contactArr, this.contactForm])
                ajax.post(requestUrls.ClPurchase.CreateOrUpdate, {
                  clPurchase: this.cgrInfo
                }).then(res => {
                  this.addVisible = false
                  this.contactArr.push(this.contactForm)   // 下拉选项
                  // this.contactPersonOrWay.push(this.contactForm['联系人'])  // 默认加选新增联系人
                  this.$Message.success('添加成功');
                })
              },
              onCancel: () => {}
            })
          } else {
            this.$Message.error('请输入正确的邮箱格式!')
          }
        } else {
          this.$Message.error('请完善信息填写!');
        }
      })
    },
    /**input  file 接收到图片 并修改 picSrc**/
    async uploadFile(event) {
      this.file = event.target.files[0];
      if (this.file) {
        this.picSrc = URL.createObjectURL(this.file);
      }
    },
    // 得到名片信息 
    async getCardInfo(file) {
      var value = '';
      var that = this;
      return new Promise(function (resolve, reject) {
        let reader = new FileReader(); //读文件
        reader.readAsDataURL(file); //转BASE64
        reader.onload = function (e) {
          var imgFile = e.target.result.split(',');//获取图片的 base64
          axios({
            method: 'post',
            url: 'https://dm-57.data.aliyun.com/rest/160601/ocr/ocr_business_card.json',
            headers: {
              "Authorization": "APPCODE 7d95997138aa4efabcdfe5798f618096"
            },
            data: {
              "inputs": [{
                "image": {
                  "dataType": 50,
                  "dataValue": imgFile[1]
                }
              }]
            },
          }).then(response => {
            value = response.data.outputs[0].outputValue;
            value = JSON.stringify(value)
            resolve(value)
          })
            .catch(error => {
              console.error("err", error)
            })
        }
      })
    },
    //   上传图片至阿里云 && 名片识别接口 识别名片信息
    async aliyunUpload() {
      var that = this;
      if (that.file) {
        var res = await upload(that.file);
        that.min_purchaserVisitListData.bcImageLocation = 'http://wxsmall.oss-cn-shenzhen.aliyuncs.com/' + res;
        var cardInfo = await that.getCardInfo(that.file);
        that.min_purchaserVisitListData.名片 = cardInfo;
      }
      return Promise.resolve(true)
    }
  }
}
</script>

<style lang="less" scoped>
.info-item {
  min-width: 150px;
  margin: 0 0 10px 20px;
  display: inline-block;
}
.info-item input:focus {
  border-radius: 5px;
}
.info-item button {
  margin: 5px;
}
select {
  width: 150px;
  display: inline-block;
}
.oss_file {
  position: relative;
  display: inline-block;
  overflow: hidden;
  height: 30px;
  vertical-align: middle;
}
.oss_file input {
  position: absolute;
  overflow: hidden;
  width: 30px;
  left: 0px;
  top: 0px;
  opacity: 0;
  cursor: pointer;
  -ms-filter: "alpha(opacity=0)";
  z-index: 99;
}
.img_style {
  display: inline-block;
  width: 30px;
  height: 30px;
  border: 1px dashed gainsboro;
  line-height: 30px;
  text-align: center;
  vertical-align: middle;
}
.picBox {
  position: absolute;
  left: 0px;
  top: 0;
  bottom: 0px;
  right: 0px;
  height: 30px;
  width: 30px;
}
.picBox {
  height: 30px;
  width: 30px;
}
.textarea {
  width: 100%;
  border: 1px solid #dddee1;
  border-radius: 6px;
  margin-top: 10px;
  padding: 6px 10px;
  outline: none;
}
</style>